import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';

export const SuspenseLoader: React.FC<{ message?: string }> = ({ message }) => (
  <div
    className={cs(
      'tw-h-full tw-w-full',
      'tw-flex tw-items-center tw-justify-center',
      'tw-cursor-progress tw-text-neutral-300',
      '[&_svg]:tw-h-16 [&_svg]:tw-w-16'
    )}
  >
    {Icons.loaderSW6} {message ?? 'Loading...'}
  </div>
);
